module.exports = __webpack_public_path__ + "static/media/pyretlogo.17cd3667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pyretlogo.png
// module id = 1730
// module chunks = 2